"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsInviteComponent = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const input_1 = require("../../components/input/input");
const input_select_1 = require("../../components/input/input.select");
const input_state_1 = require("../../components/input/input.state");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const INVITE_SUCCESS = { key: i18n_1.T.ACCOUNTS_INVITE_SUCCESS };
const INVITE_MAX = 10;
const INVITE_EMAIL_ROWS = 3;
const BASIC_ROLE_OPTIONS = [
    { role: core_api_1.IkeUserRole.USER, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_USER) },
    { role: core_api_1.IkeUserRole.ROOT, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_ADMIN) },
];
const EXTRA_ROLE_OPTIONS = [
    { role: core_api_1.IkeUserRole.VIEWER, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_VIEWER) },
    { role: core_api_1.IkeUserRole.DOWNLOADER, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_DOWNLOADER) },
    { role: core_api_1.IkeUserRole.EDITOR, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_EDITOR) },
    { role: core_api_1.IkeUserRole.DATA_ADMIN, label: (0, i18n_1.Translate)(i18n_1.T.ROLE_DATA_ADMIN) },
];
class AccountsInviteComponent extends modal_form_component_1.ModalFormComponent {
    constructor(ctrl) {
        super({
            title: i18n_1.T.ACCOUNTS_INVITE_TITLE,
            confirm: i18n_1.T.ACCOUNTS_INVITE,
            success: INVITE_SUCCESS,
        });
        this.email = new input_state_1.InputState(i18n_1.T.SIGNUP_EMAIL);
        this.role = new input_select_1.SelectInputState(i18n_1.T.ACCOUNTS_ROLE);
        this.ctrl = ctrl;
        this.addState(this.email);
        this.addState(this.role);
        BASIC_ROLE_OPTIONS.forEach((role) => this.role.addOption({ key: role.label, value: role.role }));
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_EXTRA_ROLES) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
            EXTRA_ROLE_OPTIONS.forEach((role) => this.role.addOption({ key: role.label, value: role.role }));
        }
        this.email.isRequired = true;
        this.email.type = input_state_1.InputStateTypes.TEXT;
        this.role.isRequired = true;
    }
    get nodes() {
        return [
            (0, mithril_1.m)('span', (0, i18n_1.Translate)(i18n_1.T.ACCOUNTS_INVITE_CONFIRM)),
            (0, mithril_1.m)('div', { style: 'color:' + theme_1.DefaultTheme.font.color.error }, this.role.isValid ? '' : (0, i18n_1.Translate)(i18n_1.T.ACCOUNTS_INVITE_CHOOSE_USER_ROLE)),
            input_select_1.SelectInputComponent.view(this.role),
            input_1.Input.view(this.email, { rows: INVITE_EMAIL_ROWS }),
        ];
    }
    submit() {
        const emails = this.getEmails();
        const role = this.role.value;
        return this.ctrl.inviteUsers(emails, role);
    }
    failToChange(e) {
        this.email.setError(i18n_1.T.EMAIL_INVALID);
        var existingEmails = [];
        var invalidEmails = [];
        if (core_shared_1.IkeRequestErrorChecker.isValidationFailed(e)) {
            for (const error of e.errors) {
                if (error.codes === 'already_exists') {
                    existingEmails.push(error.message);
                }
                else if (error.codes === 'invalid') {
                    invalidEmails.push(error.message);
                }
            }
        }
        if (existingEmails.length > 0) {
            notification_service_1.NotificationService.warn({
                key: i18n_1.T.ACCOUNTS_INVITE_EXISTING_USER,
                attrs: existingEmails,
            });
        }
        if (invalidEmails.length > 0) {
            notification_service_1.NotificationService.error({
                key: i18n_1.T.ACCOUNTS_INVITE_INVALID_USER,
                attrs: invalidEmails,
            });
        }
        this.email.setSelected(true);
    }
    validate() {
        const emails = this.getEmails();
        if (!this.email.isFilled || emails.length === 0) {
            this.email.setError(i18n_1.T.EMAIL_INVALID);
        }
        else if (emails.length > INVITE_MAX) {
            this.email.setError((0, i18n_1.Translate)(i18n_1.T.ACCOUNTS_INVITE_MAX, INVITE_MAX));
        }
        else {
            this.email.setError('');
        }
    }
    getEmails() {
        if (this.email.value == null) {
            return [];
        }
        const emails = this.email.value.split(/[,\n\r]/);
        const output = [];
        for (const email of emails) {
            const toAdd = email.toLowerCase().trim();
            if (output.indexOf(toAdd) > -1) {
                continue;
            }
            if (toAdd.indexOf('@') === -1) {
                continue;
            }
            output.push(toAdd);
        }
        return output;
    }
}
exports.AccountsInviteComponent = AccountsInviteComponent;
//# sourceMappingURL=accounts.confirm.invite.js.map